import { BlockUIModule } from 'primeng/blockui'
import { TooltipModule } from 'primeng/tooltip'
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { CardModule } from 'primeng/card'
import { MenubarModule } from 'primeng/menubar'
import { ButtonModule } from 'primeng/button'
import { DividerModule } from 'primeng/divider'
import { InputTextModule } from 'primeng/inputtext'
import { RadioButtonModule } from 'primeng/radiobutton'
import { AutoCompleteModule } from 'primeng/autocomplete'
import { ProgressSpinnerModule } from 'primeng/progressspinner'
import { DialogModule } from 'primeng/dialog'
import { DragDropModule } from 'primeng/dragdrop'
import { ToggleSwitchModule } from 'primeng/toggleswitch'
import { TieredMenuModule } from 'primeng/tieredmenu'
import { BadgeModule } from 'primeng/badge'
import { DockModule } from 'primeng/dock'
import { MenuModule } from 'primeng/menu'
import { DrawerModule } from 'primeng/drawer'
import { CheckboxModule } from 'primeng/checkbox'
import { TextareaModule } from 'primeng/textarea'
import { TabsModule } from 'primeng/tabs'
import { ConfirmationService, MessageService } from 'primeng/api'
import { ToastModule } from 'primeng/toast'
import { BreadcrumbModule } from 'primeng/breadcrumb'
import { PopoverModule } from 'primeng/popover'
import { OverlayModule } from 'primeng/overlay'
import { ScrollTopModule } from 'primeng/scrolltop'
import { PanelMenuModule } from 'primeng/panelmenu'
import { PasswordModule } from 'primeng/password'
import { InputOtpModule } from 'primeng/inputotp'
import { InputMaskModule } from 'primeng/inputmask'
import { SelectModule } from 'primeng/select'
import { AutoFocusModule } from 'primeng/autofocus'
import { SplitterModule } from 'primeng/splitter'
import { TableModule } from 'primeng/table';
import { AccordionModule } from 'primeng/accordion';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { PanelModule } from 'primeng/panel';
import { InputNumberModule } from 'primeng/inputnumber'
import { MessageModule } from 'primeng/message';
import { CarouselModule } from 'primeng/carousel';
import { SelectButtonModule } from 'primeng/selectbutton'

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    BlockUIModule,
    TooltipModule,
    CardModule,
    MenubarModule,
    ButtonModule,
    DividerModule,
    InputTextModule,
    RadioButtonModule,
    AutoCompleteModule,
    ProgressSpinnerModule,
    DialogModule,
    DragDropModule,
    ToggleSwitchModule,
    TieredMenuModule,
    BadgeModule,
    DockModule,
    MenuModule,
    DrawerModule,
    CheckboxModule,
    TextareaModule,
    TabsModule,
    ToastModule,
    BreadcrumbModule,
    PopoverModule,
    ScrollTopModule,
    PanelMenuModule,
    PasswordModule,
    InputOtpModule,
    InputMaskModule,
    SelectModule,
    SplitterModule,
    TableModule,
    AccordionModule,
    IconFieldModule,
    InputIconModule,
    InputNumberModule,
    OverlayModule,
    ScrollPanelModule,
    ConfirmDialogModule,
    MessageModule,
    PanelModule,
    CarouselModule,
    SelectButtonModule
  ],
  exports: [
    BlockUIModule,
    TooltipModule,
    CardModule,
    MenubarModule,
    ButtonModule,
    DividerModule,
    InputTextModule,
    RadioButtonModule,
    AutoCompleteModule,
    ProgressSpinnerModule,
    DialogModule,
    DragDropModule,
    ToggleSwitchModule,
    TieredMenuModule,
    BadgeModule,
    DockModule,
    MenuModule,
    DrawerModule,
    CheckboxModule,
    TextareaModule,
    TabsModule,
    ToastModule,
    BreadcrumbModule,
    PopoverModule,
    ScrollTopModule,
    PanelMenuModule,
    PasswordModule,
    InputOtpModule,
    InputMaskModule,
    SelectModule,
    AutoFocusModule,
    SplitterModule,
    TableModule,
    AccordionModule,
    IconFieldModule,
    InputIconModule,
    InputNumberModule,
    OverlayModule,
    ScrollPanelModule,
    ConfirmDialogModule,
    MessageModule,
    PanelModule,
    CarouselModule,
    SelectButtonModule
  ],
  providers: [MessageService, ConfirmationService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PrimeNGModule { }
